export const COMPLIANCE_APPLICATION_STATUS = {
  COMPLIANT: 'compliant',
  COMPLIANCE_STARTED: 'complianceStarted',
  NEEDS_REVIEW: 'needsReview',
} as const;

export const COMPLIANCE_ERROR_TYPES = {
  APPLICATION_ALREADY_COMPLIANT: 'APPLICATION_ALREADY_COMPLIANT',
} as const;
